<template>
  <div style="width:100%;min-height:100vh;background:rgb(237,241,255)">
    <van-nav-bar style="position:fixed;top:0;left:0;width:100%;background-color:#ede9e7" title="绑定支付宝收款" left-arrow @click-left="$router.back()" />
    <div style="height:46px"></div>
    <div class="usrse">
      <div class="hgs">
        <div class="nams">真实姓名</div>
        <van-cell-group>
          <van-field v-model="cardInfo.bank_owner" placeholder="请输入真实姓名" />
        </van-cell-group>
      </div>
      <div class="hgs">
        <div class="nams">支付宝账号</div>
        <van-cell-group>
          <van-field v-model="cardInfo.bank_no" placeholder="请输入支付宝账号（手机号或邮箱）" />
        </van-cell-group>
      </div>
      <div class="hgs">
        <div class="nams">支付宝收款二维码（选填）</div>
        <div class="qr-upload" @click="$refs.fileInput.click()">
          <img v-if="qrPreview" :src="qrPreview" class="qr-img" />
          <div v-else class="qr-placeholder">
            <div class="plus">+</div>
            <p>点击上传二维码</p>
          </div>
        </div>
        <input ref="fileInput" type="file" accept="image/*" style="display:none" @change="onFileChange" />
      </div>
      <div class="hgs">
        <div class="nams">支付密码</div>
        <van-cell-group>
          <van-field v-model="cardInfo.pay_pass" type="password" autocomplete="new-password" placeholder="请输入支付密码" />
        </van-cell-group>
      </div>
      <van-button type="info" style="margin-top:20px;width:100%" @click="bindCard">确认绑定</van-button>
      <div style="height:60px"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'addAlipayCard',
  data() {
    return {
      cardInfo: { bank_owner: '', bank_no: '', pay_pass: '' },
      qrFile: null,
      qrPreview: null,
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.qrFile = file;
      this.qrPreview = URL.createObjectURL(file);
    },
    bindCard() {
      const that = this;
      if (!that.cardInfo.bank_owner) { that.$parent.showTost(0, '请填写真实姓名'); return; }
      if (!that.cardInfo.bank_no)    { that.$parent.showTost(0, '请填写支付宝账号'); return; }
      if (!that.cardInfo.pay_pass)   { that.$parent.showTost(0, '请填写支付密码'); return; }
      const formData = new FormData();
      formData.append('card_type', 4);
      formData.append('bank_owner', that.cardInfo.bank_owner);
      formData.append('bank_no', that.cardInfo.bank_no);
      formData.append('bank', '支付宝');
      formData.append('pay_pass', that.cardInfo.pay_pass);
      if (that.qrFile) formData.append('qr_code', that.qrFile);
      that.$parent.showLoading();
      that.$apiFun.upload('/api/bindcard', formData).then(res => {
        if (res.code != 200) { that.$parent.showTost(0, res.message); }
        else { that.$parent.showTost(1, '支付宝绑定成功'); that.$router.back(); }
        that.$parent.hideLoading();
      }).catch(() => that.$parent.hideLoading());
    },
  },
};
</script>
<style lang="scss" scoped>
.usrse { background:#fff; box-sizing:border-box; padding:6px 20px 0; }
.nams { font-size:0.38rem; color:#000; margin-top:10px; font-weight:700; }
.hgs { margin-bottom:10px; }
.qr-upload {
  margin-top:10px; width:3rem; height:3rem; border:1px dashed #ccc;
  border-radius:8px; display:flex; align-items:center; justify-content:center; cursor:pointer;
}
.qr-img { width:100%; height:100%; object-fit:cover; border-radius:8px; }
.qr-placeholder { text-align:center; color:#ccc;
  .plus { font-size:1rem; line-height:1; }
  p { font-size:0.28rem; margin-top:5px; }
}
</style>



// WEBPACK FOOTER //
// src/components/addAlipayCard.vue